module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0154.jpg?v=83559d85";